import moment from 'moment';

export function formatTimestamp(ts) {
	return moment(ts).format("Do MMMM YYYY à HH:mm:ss");
}